module.exports = __webpack_public_path__ + "static/media/021-building.199ec65d.svg";